<div class="flex flex--align-start ps-xsmall-b" [class.ps-large-l]="indented()" [attr.data-testid]="testId()">
  @if (count()) {
    <span class="nowrap ms-xxsmall-r">{{ count() }} x</span>
  }
  @if (icon()) {
    <fcom-icon [name]="icon()" class="ms-xxsmall-r flex--shrink0"></fcom-icon>
  }
  <span class="flex-1">
    @if (title()) {
      {{ title() }}
    } @else if (titleKey()) {
      {{ titleKey() | finLocalization: titleParams() }}
    }
  </span>
  @if (price()) {
    <span class="nowrap ps-small-l" [class.heather-800-text]="accentPrice()" [class.text-icon-accent]="accentPrice()">
      {{ price() | finPrice }}
    </span>
  }
</div>
